import { CuboidFace } from '../render/mesh/cuboid/cuboid-helper';
import { Axis } from '../renderers/edit-panel/edit-panel.component';

export class EditPanelState {
  highlightedTranslationAxis?: Axis;
  highlightedFoiSelector?: CuboidFace;
  isExpanded = true;
  location: 'left' | 'bottom' = 'left';
}
